import React, { useEffect, useState } from "react";
import classNames from "classnames";
import "./ScrollToTop.scss";
import { Svg, SVG_ICONS } from "../Svg/Svg";
import { useWindowSize } from "../../../hooks/window-hooks";
import { Container } from "../../Grid/Grid";

export const ScrollToTop: React.FC = () => {
  const [showTopBtn, setShowTopBtn] = useState(false);
  const [isFooterReached, setFooterReached] = useState(false);
  const { isMobile } = useWindowSize();

  const wrapClass = classNames("scroll", {
    open: !!showTopBtn,
    absolute: isFooterReached,
  });

  useEffect(() => {
    const onScroll = () => {
      if (
        document.getElementById("main-body")!.scrollTop >
        document.getElementById("main-body")!.clientHeight / 2
      ) {
        setShowTopBtn(true);
      } else {
        setShowTopBtn(false);
      }

      if (
        document.getElementById("main-body")!.scrollTop +
          document.getElementById("main-body")!.clientHeight +
          124 >=
        document.getElementById("main-body")!.scrollHeight
      ) {
        setFooterReached(true);
      } else {
        setFooterReached(false);
      }
    };

    const onScrollMobile = () => {
      if (window.scrollY > document.body.scrollHeight / 2) {
        setShowTopBtn(true);
      } else {
        setShowTopBtn(false);
      }

      if (
        window.scrollY + window.innerHeight + 149 >=
        document.body.scrollHeight
      ) {
        setFooterReached(true);
      } else {
        setFooterReached(false);
      }
    };

    if (!isMobile) {
      document
        .getElementById("main-body")!
        .addEventListener("scroll", onScroll);
    } else {
      window.addEventListener("scroll", onScrollMobile);
    }

    return () => {
      document
        .getElementById("main-body")!
        .removeEventListener("scroll", onScroll);

      window.removeEventListener("scroll", onScrollMobile);
    };
  }, [isMobile]);

  const handleOnClick = () => {
    if (!isMobile) {
      document.getElementById("main-body")!.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } else {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  return (
    <Container className="scroll-container">
      <div className="scroll-wrapper">
        <div className={wrapClass}>
          <button className="scroll__button" onClick={handleOnClick}>
            <Svg icon={SVG_ICONS.ARROW_UP} width={24} height={24} />
          </button>
        </div>
      </div>
    </Container>
  );
};
